<mat-card-subtitle
  *ngIf="eligibility?.data"
  fxLayout="row"
  fxLayoutAlign="space-between center"
  fxLayoutGap="1rem"
  class="my-0 py-0"
>
  <span fxFlex>
    {{ 'patient-details.eligibility-card.benefits-provided' | translate }}
    <ng-container *ngIf="eligibility.clinicCarrierName">
      {{ 'common.for' | translate }}
      <span
        [matTooltip]="
          'patient-details.eligibility-card.carrier-hint' | translate
        "
        class="text-secondary"
      >
        {{ eligibility.clinicCarrierName }}
      </span>
    </ng-container>
    {{ 'common.by' | translate }}
    <span
      matTooltip="This is the payer's name assigned by the clearinghouse {{
        (eligibility.source || '').replace('-', ' ') | mmxTitlecase
      }}. Payer ID: {{ eligibility.carrierSlug }}"
      class="text-secondary"
    >
      {{ eligibility.carrierName }}
    </span>
    <ng-container *ngIf="eligibility.source">
      {{ 'common.via' | translate }}
      <span
        matTooltip="This is the clearinghouse used to retrieve the patient's eligibility and benefits"
        class="text-secondary"
      >
        {{ eligibility.source.replace('-', ' ') | mmxTitlecase }}.
      </span>
    </ng-container>
    {{ 'patient-details.eligibility-card.accurate-of' | translate }}
    <span [matTooltip]="eligibility.createdAt | momentDateTime: 'local'">{{
      eligibility.createdAt
        | momentDate: 'local'
    }}</span>.
  </span>
  <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="0.5rem" class="pt-2 pb-2">
    <ng-container *ngIf="showAddAppointmentButton">
      <button
        *appHasPermission="'appointment.create'"
        mat-stroked-button
        type="button"
        (click)="onAddAppointmentClick()"
      >
        <mat-icon>add</mat-icon>
        {{ 'patient-details.eligibility-card.add-appointment' | translate }}
      </button>
    </ng-container>

    <mat-menu #eligibilityMenu="matMenu">
      <button mat-menu-item (click)="download($event)" *ngIf="eligibility">
        <mat-icon>print</mat-icon>
        <span>{{ 'common.print' | translate }}</span>
      </button>

      <button mat-menu-item (click)="openRawResponse()">
        <mat-icon>code</mat-icon>
        <span>{{
          'patient-details.eligibility-card.view-raw-response' | translate
          }}</span>
      </button>
    </mat-menu>

    @if (showAddEstimate) {
      <ng-container *appHasModule="'shopperEstimates'">
        <button
          *appHasPermission="'shopper-estimate.create'"
          mat-stroked-button
          type="button"
          [disabled]="isAddingEstimate"
          (click)="addEstimate()"
        >
          <mat-spinner *ngIf="isAddingEstimate" diameter="18" class="inline-spinner"></mat-spinner>
          <mat-icon *ngIf="!isAddingEstimate">add</mat-icon>
          {{ 'patient-details.eligibility-card.add-estimate' | translate }}
        </button>
      </ng-container>
    }

    <button mat-icon-button [matMenuTriggerFor]="eligibilityMenu" *ngIf="eligibility">
      <mat-icon>more_vert</mat-icon>
    </button>
  </div>
</mat-card-subtitle>

<mat-card-content *ngIf="eligibility?.data">
  <div
    *ngIf="
      eligibility &&
      eligibility.data &&
      eligibility.data.plans &&
      eligibility.data.plans.length > 0
    "
    fxLayout="row"
    fxLayoutAlign="space-between center"
  >
    @if (eligibility.data.plans.length <= 1) {
      <div
        class="box"
        fxFlex="15"
        fxFlex.lt-md="100"
        fxLayout="row"
      >
        @if (eligibility.valid) {
          @if (eligibility.active) {
            <mmx-eligibility-status
              [tooltip]="'Patient has active coverage'"
              [icon]="'check_circle_outline'"
              [color]="'green'"
              [status]="'common.active'"
            ></mmx-eligibility-status>
          } @else {
            @if(eligibility.hasMedicareAdvantagePlan) {
              <mmx-eligibility-status
                [tooltip]="'patient-details.eligibility-card.medicare-advantage-hint'"
                [icon]="'error_outline'"
                [color]="'red'"
                [status]="'patient-details.eligibility-card.medicare-advantage'"
              ></mmx-eligibility-status>
            } @else if(eligibility.hasManagedMedicaidPlan) {
              <mmx-eligibility-status
                [tooltip]="'patient-details.eligibility-card.managed-medicaid-hint'"
                [icon]="'error_outline'"
                [color]="'red'"
                [status]="'patient-details.eligibility-card.managed-medicaid'"
                [alternativeInsuranceName]="eligibility.alternativeInsuranceName"
              ></mmx-eligibility-status>
            } @else {
              <mmx-eligibility-status
                [tooltip]="'Eligibility not active. Out of date.'"
                [icon]="'error_outline'"
                [color]="'red'"
                [status]="'common.inactive'"
              ></mmx-eligibility-status>
            }
          }
        } @else {
          <mmx-eligibility-status
            [tooltip]="'patient-details.eligibility-card.invalid-hint'"
            [icon]="'error_outline'"
            [color]="'red'"
            [status]="'common.invalid'"
          ></mmx-eligibility-status>
        }
      </div>
    }
    <mat-form-field
      appearance="fill"
      fxFlex
      *ngIf="
        eligibility &&
        eligibility.data &&
        eligibility.data.plans &&
        eligibility.data.plans.length > 1
      "
    >
      <mat-label>{{ 'common.plan' | translate }}</mat-label>
      <mat-select [formControl]="planControl">
        <mat-option
          *ngFor="let plan of eligibility.data.plans"
          [value]="plan"
        >
          {{ plan.planName || plan.groupName }}
          <ng-container *ngIf="plan.status">({{ plan.status }})</ng-container>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="active-right mb-6" fxLayout="row wrap" fxLayoutWrap="wrap">
    <div
      class="box"
      fxFlex="33"
      fxFlex.lt-md="50"
      fxLayout="column"
      *ngIf="eligibilityBeginDate"
    >
      <div
        fxLayout="row"
        fxLayoutAlign="start center"
        [matTooltip]="
          'patient-details.eligibility-card.eligibility-begin-date-hint'
            | translate
        "
      >
        <mat-icon>date_range</mat-icon>
        <div fxFlex class="label text-secondary uppercase text-xs">
          {{
            'patient-details.eligibility-card.eligibility-begin-date'
              | translate
          }}
        </div>
      </div>
      <div class="value">
        <mmx-copy-text>{{
          eligibilityBeginDate
            ? eligibilityBeginDate.format('MM/DD/YYYY')
            : 'N/A'
        }}</mmx-copy-text>
      </div>
    </div>

    <div
      class="box"
      fxFlex="33"
      fxFlex.lt-md="50"
      fxLayout="column"
      *ngIf="eligibilityEndDate"
    >
      <div
        fxLayout="row"
        fxLayoutAlign="start center"
        [matTooltip]="
          'patient-details.eligibility-card.eligibility-end-date-hint'
            | translate
        "
      >
        <mat-icon>date_range</mat-icon>
        <div fxFlex class="label text-secondary uppercase text-xs">
          {{
            'patient-details.eligibility-card.eligibility-end-date'
              | translate
          }}
        </div>
      </div>
      <div class="value">
        <mmx-copy-text>{{
          eligibilityEndDate ? eligibilityEndDate.format('MM/DD/YYYY') : 'N/A'
        }}</mmx-copy-text>
      </div>
    </div>

    <ng-container *ngIf="planControl.value">
      <ng-container *ngFor="let fact of planFacts; index as i">
        <div
          *ngIf="getPlanFact(fact.key)"
          class="box"
          fxFlex="33"
          fxFlex.lt-md="50"
          fxLayout="column"
        >
          <div
            fxLayout="row"
            fxLayoutAlign="start center"
            [matTooltip]="fact.tooltip"
          >
            <mat-icon>{{ fact.icon }}</mat-icon>
            <div fxFlex class="label text-secondary uppercase text-xs">
              {{ fact.label }}
            </div>
          </div>
          <div class="value" [matTooltip]="getPlanFact(fact.key)">
            <mmx-copy-text>{{ getPlanFact(fact.key) }}</mmx-copy-text>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <div
      class="box"
      fxFlex="33"
      fxFlex.lt-md="50"
      fxLayout="column"
      *ngIf="eligibility.data.payer?.name?.nick || eligibility.data.payer?.name?.given"
    >
      <div
        fxLayout="row"
        fxLayoutAlign="start center"
        [matTooltip]="
          'patient-details.eligibility-card.eligibility-payer-name-hint'
            | translate
        "
      >
        <mat-icon>account_balance</mat-icon>
        <div fxFlex class="label text-secondary uppercase text-xs">
          {{
            'patient-details.eligibility-card.eligibility-payer-name'
              | translate
          }}
        </div>
      </div>
      <div class="value">
        <mmx-copy-text>{{eligibility.data.payer?.name?.nick || eligibility.data.payer?.name?.given}}</mmx-copy-text>
      </div>
    </div>
  </div>

  <form *ngIf="eligibility?.data.coverage" [formGroup]="filtersForm">
    <header class="subheading">
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center"
        fxLayoutGap="1rem"
      >
        <mat-slide-toggle formControlName="filtersEnabled" color="primary">{{
          'common.filters' | translate
        }}</mat-slide-toggle>
        <mat-form-field appearance="fill" fxFlex>
          <mat-label>{{
            'patient-details.eligibility-card.service-types' | translate
          }}</mat-label>
          <mat-select formControlName="serviceCodes" multiple>
            <mat-option>
              <ngx-mat-select-search
                formControlName="serviceFilterCtrl"
                [placeholderLabel]="
                  'patient-details.eligibility-card.select-search-placeholder'
                    | translate
                "
                [noEntriesFoundLabel]="
                  'patient-details.eligibility-card.select-search-no-entries'
                    | translate
                "
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option
              *ngFor="let service of filteredServiceTypes | async"
              [value]="service.code"
            >
              [{{ service.code }}] {{ service.name | mmxTitlecase }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" fxFlex>
          <mat-label>{{
            'patient-details.eligibility-card.place-types' | translate
          }}</mat-label>
          <mat-select formControlName="placeTypes" multiple>
            <mat-option
              *ngFor="let type of PlaceOfServiceTypes"
              [value]="type.value"
            >
              {{ type.viewValue | mmxTitlecase }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-slide-toggle formControlName="inNetwork" color="primary">
          {{
            filtersForm.value.inNetwork
              ? ('patient-details.eligibility-card.in-network' | translate)
              : ('patient-details.eligibility-card.out-of-network'
                | translate)
          }}
        </mat-slide-toggle>
      </div>
      <div *ngIf="hasErrors" class="text-warn">
        {{ 'patient-details.eligibility-card.filtering-disable' | translate }}
      </div>
    </header>
  </form>

  <mat-accordion multi>
    <mat-expansion-panel expanded *ngIf="hasErrors">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'common.errors' | translate }}
        </mat-panel-title>
        <mat-panel-description>
          <button
            mat-icon-button
            [matTooltip]="'common.help-center' | translate"
            (click)="goToCommonEligibilityErrorsArticle()"
          >
            <mat-icon>help</mat-icon>
          </button>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <mat-panel-content class="panel-content">
        <ol>
          <li *ngFor="let error of eligibility?.data.errors">
            [{{ error.code }}] {{ error.message }}
            <div *ngIf="error.entity" fxLayout="column">
              <span *ngIf="error.entity.organization_name">{{
                error.entity.organization_name
              }}</span>
              <span *ngIf="error.entity.name">{{
                error.entity.name | humanName: true
              }}</span>
              <span *ngIf="error.entity.npi"
                >{{
                  'patient-details.eligibility-card.data.npi' | translate
                }}: {{ error.entity.npi }}</span
              >
              <span *ngIf="error.entity.url"
                >{{
                  'patient-details.eligibility-card.data.url' | translate
                }}:
                <a [href]="error.entity.url" rel="nofollow noopener noreferrer" target="_blank">{{
                  error.entity.url
                }}</a></span
              >
              <span *ngIf="error.entity.phone"
                >{{
                  'patient-details.eligibility-card.data.phone' | translate
                }}: {{ error.entity.phone | phone }}</span
              >
              <span *ngIf="error.entity.fax"
                >{{
                  'patient-details.eligibility-card.data.fax' | translate
                }}: {{ error.entity.fax | phone }}</span
              >
              <span *ngIf="error.entity.email"
                >{{
                  'patient-details.eligibility-card.data.email' | translate
                }}: {{ error.entity.email }}</span
              >
              <div *ngIf="error.entity.address" fxLayout="column">
                <span
                  >{{
                    'patient-details.eligibility-card.data.address'
                      | translate
                  }}:</span
                >
                <address
                  [innerHTML]="error.entity.address | address: true"
                ></address>
              </div>
            </div>
          </li>
        </ol>
      </mat-panel-content>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="eligibility?.data.subscriber">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'patient-details.eligibility-card.subscriber' | translate }}
        </mat-panel-title>
        <mat-panel-description>
          {{ eligibility.data.subscriber.name | humanName: true }}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <mat-panel-content class="panel-content" fxLayout="column">
        <ng-container *ngIf="eligibility?.data.subscriber.name">
          <span class="text-secondary uppercase text-xs">{{
            'patient-details.eligibility-card.subscriber-name' | translate
          }}</span>
          <span class="mb-2">{{
            eligibility.data.subscriber.name | humanName: true
          }}</span>
        </ng-container>
        <ng-container *ngIf="eligibility?.data.subscriber.id">
          <span class="text-secondary uppercase text-xs">{{
            'patient-details.eligibility-card.subscriber-member-id'
              | translate
          }}</span>
          <span class="mb-2">{{ eligibility?.data.subscriber.id }}</span>
        </ng-container>
        <ng-container *ngIf="eligibility?.data.subscriber.groupNumber">
          <span class="text-secondary uppercase text-xs">{{
            'patient-details.eligibility-card.subscriber-group-number'
              | translate
          }}</span>
          <span class="mb-2">{{
            eligibility?.data.subscriber.groupNumber
          }}</span>
        </ng-container>
        <ng-container *ngIf="eligibility?.data.subscriber.groupName">
          <span class="text-secondary uppercase text-xs">{{
            'patient-details.eligibility-card.subscriber-group-name'
              | translate
          }}</span>
          <span class="mb-2">{{
            eligibility?.data.subscriber.groupName
          }}</span>
        </ng-container>
        <ng-container *ngIf="eligibility?.data.subscriber.dob">
          <span class="text-secondary uppercase text-xs">{{
            'patient-details.eligibility-card.subscriber-dob' | translate
          }}</span>
          <span class="mb-2">{{
            eligibility?.data.subscriber.dob | dob
          }}</span>
        </ng-container>
        <ng-container *ngIf="eligibility?.data.subscriber.gender">
          <span class="text-secondary uppercase text-xs">{{
            'patient-details.eligibility-card.subscriber-gender' | translate
          }}</span>
          <span class="mb-2">{{
            eligibility?.data.subscriber.gender | sex
          }}</span>
        </ng-container>
        <ng-container *ngIf="eligibility?.data.subscriber.address">
          <span class="text-secondary uppercase text-sm">{{
            'patient-details.eligibility-card.subscriber-address' | translate
          }}</span>
          <address
            [innerHTML]="eligibility?.data.subscriber.address | address: true"
          ></address>
        </ng-container>
      </mat-panel-content>
    </mat-expansion-panel>

    <mat-expansion-panel
      *ngIf="eligibility?.data.coverage && eligibility.data.coverage.pcp"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{
            'patient-details.eligibility-card.primary-care-physician'
              | translate
          }}
        </mat-panel-title>
        <mat-panel-description>
          <ng-container
            *ngIf="
              eligibility?.data.coverage.pcp.organization_name;
              else pcpHumanName
            "
          >
            {{ eligibility?.data.coverage.pcp.organization_name }}
          </ng-container>
          <ng-template #pcpHumanName>
            {{ eligibility?.data.coverage.pcp.name | humanName: true }}
          </ng-template>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <mat-panel-content class="panel-content" fxLayout="column">
        <ng-container
          *ngIf="eligibility?.data.coverage.pcp.organization_name"
        >
          <span class="text-secondary uppercase text-xs">{{
            'patient-details.eligibility-card.data.organization-name'
              | translate
          }}</span>
          <span class="mb-2">{{
            eligibility?.data.coverage.pcp.organization_name
          }}</span>
        </ng-container>
        <ng-container *ngIf="eligibility?.data.coverage.pcp.name">
          <span class="text-secondary uppercase text-xs">{{
            'patient-details.eligibility-card.data.name' | translate
          }}</span>
          <span class="mb-2">{{
            eligibility.data.coverage.pcp.name | humanName: true
          }}</span>
        </ng-container>
        <ng-container *ngIf="eligibility?.data.coverage.pcp.npi">
          <span class="text-secondary uppercase text-xs">{{
            'patient-details.eligibility-card.data.npi' | translate
          }}</span>
          <span class="mb-2">{{ eligibility?.data.coverage.pcp.npi }}</span>
        </ng-container>
        <ng-container *ngIf="eligibility?.data.coverage.pcp.url">
          <span class="text-secondary uppercase text-xs">{{
            'patient-details.eligibility-card.data.url' | translate
          }}</span>
          <span class="mb-2"
            ><a
              [href]="eligibility?.data.coverage.pcp.url"
              rel="nofollow noopener noreferrer"
              target="_blank"
              >{{ eligibility?.data.coverage.pcp.url }}</a
            ></span
          >
        </ng-container>
        <ng-container *ngIf="eligibility?.data.coverage.pcp.phone">
          <span class="text-secondary uppercase text-xs">{{
            'patient-details.eligibility-card.data.phone' | translate
          }}</span>
          <span class="mb-2">{{
            eligibility?.data.coverage.pcp.phone | phone
          }}</span>
        </ng-container>
        <ng-container *ngIf="eligibility?.data.coverage.pcp.fax">
          <span class="text-secondary uppercase text-xs">{{
            'patient-details.eligibility-card.data.fax' | translate
          }}</span>
          <span class="mb-2">{{
            eligibility?.data.coverage.pcp.fax | phone
          }}</span>
        </ng-container>
        <ng-container *ngIf="eligibility?.data.coverage.pcp.email">
          <span class="text-secondary uppercase text-xs">{{
            'patient-details.eligibility-card.data.email' | translate
          }}</span>
          <span class="mb-2">{{ eligibility?.data.coverage.pcp.email }}</span>
        </ng-container>
        <ng-container *ngIf="eligibility?.data.coverage.pcp.address">
          <span class="text-secondary uppercase text-xs">{{
            'patient-details.eligibility-card.data.address' | translate
          }}</span>
          <address
            [innerHTML]="
              eligibility?.data.coverage.pcp.address | address: true
            "
          ></address>
        </ng-container>
      </mat-panel-content>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="eligibility?.data.payer">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'patient-details.eligibility-card.payer' | translate }}
        </mat-panel-title>
        <mat-panel-description>
          {{ eligibility?.data.payer.organization_name }}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <mat-panel-content class="panel-content" fxLayout="column">
        <ng-container *ngIf="eligibility?.data.payer.organization_name">
          <span class="text-secondary uppercase text-sm">{{
            'patient-details.eligibility-card.data.organization-name'
              | translate
          }}</span>
          <span class="mb-2">{{
            eligibility?.data.payer.organization_name
          }}</span>
        </ng-container>
        <ng-container *ngIf="eligibility?.data.payer.name">
          <span class="text-secondary uppercase text-sm">{{
            'patient-details.eligibility-card.data.payer-name' | translate
          }}</span>
          <span class="mb-2">{{
            eligibility.data.payer.name | humanName: true
          }}</span>
        </ng-container>
        <ng-container *ngIf="eligibility?.data.payer.url">
          <span class="text-secondary uppercase text-sm">{{
            'patient-details.eligibility-card.data.url' | translate
          }}</span>
          <span class="mb-2"
            ><a
              [href]="eligibility?.data.payer.url"
              rel="nofollow noopener noreferrer"
              target="_blank"
              >{{ eligibility?.data.payer.url }}</a
            ></span
          >
        </ng-container>
        <ng-container *ngIf="eligibility?.data.payer.phone">
          <span class="text-secondary uppercase text-sm">{{
            'patient-details.eligibility-card.data.phone' | translate
          }}</span>
          <span class="mb-2">{{
            eligibility?.data.payer.phone | phone
          }}</span>
        </ng-container>
        <ng-container *ngIf="eligibility?.data.payer.fax">
          <span class="text-secondary uppercase text-sm">{{
            'patient-details.eligibility-card.data.fax' | translate
          }}</span>
          <span class="mb-2">{{ eligibility?.data.payer.fax | phone }}</span>
        </ng-container>
        <ng-container *ngIf="eligibility?.data.payer.email">
          <span class="text-secondary uppercase text-sm">{{
            'patient-details.eligibility-card.data.email' | translate
          }}</span>
          <span class="mb-2">{{ eligibility?.data.payer.email }}</span>
        </ng-container>
        <ng-container *ngIf="eligibility?.data.payer.address">
          <span class="text-secondary uppercase text-sm">{{
            'patient-details.eligibility-card.data.address' | translate
          }}</span>
          <address
            [innerHTML]="eligibility?.data.payer.address | address: true"
          ></address>
        </ng-container>
      </mat-panel-content>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="additionalPayers.length">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'patient-details.eligibility-card.additional-payers' | translate }}
          <mat-icon
            class="additional-payers-hint"
            [matTooltip]="
              'patient-details.eligibility-card.additional-payers-hint'
                | translate
            "
            >info_outline</mat-icon
          >
        </mat-panel-title>
        <mat-panel-description>
          {{ additionalPayerNames }}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <mat-panel-content class="panel-content" fxLayout="column">
        <div
          *ngFor="let payer of additionalPayers; last as isLast"
          [class.additional-payer--divided]="!isLast"
          fxLayout="column"
        >
          <span class="text-primary mb-2">{{ payer.name }}</span>
          <ng-container *ngIf="payer.coverage_order">
            <span class="text-secondary uppercase text-sm">{{
              'patient-details.eligibility-card.additional-payer-order'
                | translate
            }}</span>
            <span class="mb-2">{{
              'common.' + payer.coverage_order | translate
            }}</span>
          </ng-container>
          <ng-container *ngIf="payer.type">
            <span class="text-secondary uppercase text-sm">{{
              'patient-details.eligibility-card.additional-payer-type'
                | translate
            }}</span>
            <span class="mb-2">{{ payer.type }}</span>
          </ng-container>
          <ng-container *ngIf="payer.description">
            <span class="text-secondary uppercase text-sm">{{
              'patient-details.eligibility-card.additional-payer-description'
                | translate
            }}</span>
            <span class="mb-2">{{ payer.description }}</span>
          </ng-container>
          <ng-container *ngIf="payer.payer_id">
            <span class="text-secondary uppercase text-sm">{{
              'patient-details.eligibility-card.additional-payer-payer-id'
                | translate
            }}</span>
            <span class="mb-2"
              ><mmx-copy-text>{{ payer.payer_id }}</mmx-copy-text></span
            >
          </ng-container>
          <ng-container *ngIf="payer.member_id">
            <span class="text-secondary uppercase text-sm">{{
              'patient-details.eligibility-card.additional-payer-member-id'
                | translate
            }}</span>
            <span class="mb-2"
              ><mmx-copy-text>{{ payer.member_id }}</mmx-copy-text></span
            >
          </ng-container>
          <ng-container *ngIf="payer.plan_number">
            <span class="text-secondary uppercase text-sm">{{
              'patient-details.eligibility-card.additional-payer-plan-number'
                | translate
            }}</span>
            <span class="mb-2"
              ><mmx-copy-text>{{ payer.plan_number }}</mmx-copy-text></span
            >
          </ng-container>
          <ng-container *ngIf="payer.policy_number">
            <span class="text-secondary uppercase text-sm">{{
              'patient-details.eligibility-card.additional-payer-policy-number'
                | translate
            }}</span>
            <span class="mb-2"
              ><mmx-copy-text>{{ payer.policy_number }}</mmx-copy-text></span
            >
          </ng-container>
          <ng-container *ngIf="payer.group_number">
            <span class="text-secondary uppercase text-sm">{{
              'patient-details.eligibility-card.additional-payer-group-number'
                | translate
            }}</span>
            <span class="mb-2"
              ><mmx-copy-text>{{ payer.group_number }}</mmx-copy-text></span
            >
          </ng-container>
          <ng-container *ngIf="payer.network_name">
            <span class="text-secondary uppercase text-sm">{{
              'patient-details.eligibility-card.additional-payer-network'
                | translate
            }}</span>
            <span class="mb-2">{{ payer.network_name }}</span>
          </ng-container>
          <ng-container *ngIf="payer.coordination_of_benefits_date">
            <span class="text-secondary uppercase text-sm">{{
              'patient-details.eligibility-card.additional-payer-cob-date'
                | translate
            }}</span>
            <span class="mb-2">{{ payer.coordination_of_benefits_date }}</span>
          </ng-container>
          <ng-container *ngIf="payer.benefit_begin_date">
            <span class="text-secondary uppercase text-sm">{{
              'patient-details.eligibility-card.additional-payer-begin-date'
                | translate
            }}</span>
            <span class="mb-2">{{ payer.benefit_begin_date }}</span>
          </ng-container>
          <ng-container *ngIf="payer.phone">
            <span class="text-secondary uppercase text-sm">{{
              'patient-details.eligibility-card.data.phone' | translate
            }}</span>
            <span class="mb-2">{{ payer.phone | phone }}</span>
          </ng-container>
          <ng-container *ngIf="payer.url">
            <span class="text-secondary uppercase text-sm">{{
              'patient-details.eligibility-card.data.url' | translate
            }}</span>
            <span class="mb-2"
              ><a [href]="payer.url" rel="nofollow noopener noreferrer" target="_blank">{{
                payer.url
              }}</a></span
            >
          </ng-container>
          <ng-container *ngIf="payer.address">
            <span class="text-secondary uppercase text-sm">{{
              'patient-details.eligibility-card.data.address' | translate
            }}</span>
            <address [innerHTML]="payer.address | address: true"></address>
          </ng-container>
        </div>
      </mat-panel-content>
    </mat-expansion-panel>

    <mat-expansion-panel
      *ngIf="
        eligibility &&
        eligibility.data &&
        eligibility.data.coverage &&
        eligibility.data.coverage.messages &&
        eligibility.data.coverage.messages.length > 0
      "
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'common.messages' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-panel-content class="panel-content" fxLayout="column">
        <div
          *ngFor="let message of eligibility.data.coverage.messages"
          fxLayout="column"
        >
          <span *ngIf="message.title" class="text-primary">
            {{ message.title }}
          </span>
          <span>{{ message.message }}</span>
        </div>
      </mat-panel-content>
    </mat-expansion-panel>

    <!-- Deductible -->
    <mat-expansion-panel
      *ngIf="
        eligibility &&
        eligibility.data &&
        eligibility.data.coverage &&
        hasSome(eligibility.data.coverage.deductibles)
      "
      [expanded]="eligibility.selectedDeductible == null"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'patient-details.eligibility-card.deductible' | translate }}
        </mat-panel-title>
        <mat-panel-description
          *ngIf="eligibility.selectedDeductible === 'none'"
        >
          <span class="text-warn">{{ 'common.none' | translate }}</span>
        </mat-panel-description>
        <mat-panel-description
          *ngIf="
            eligibility.selectedDeductible &&
            eligibility.selectedDeductible !== 'none' &&
            (eligibility.selectedDeductible.benefit_amount ||
              deductible.remaining_amount)
          "
        >
          <span *ngIf="eligibility.selectedDeductible.ppSelected" class="text-secondary">
            ({{ 'patient-details.eligibility-card.auto-selected' | translate }})&nbsp;
          </span>
          {{
            eligibility.selectedDeductible.benefit_amount.amount
              | currency
                : eligibility.selectedDeductible.benefit_amount.currency
          }}
          {{ eligibility.selectedDeductible.time_period | mmxTitlecase }}
          <ng-container
            *ngIf="eligibility.selectedDeductible.remaining_amount"
          >
            /
            {{
              eligibility.selectedDeductible.remaining_amount?.amount
                | currency
                  : eligibility.selectedDeductible.remaining_amount?.currency
            }}
            remaining
          </ng-container>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <mat-panel-content class="panel-content table-like" fxLayout="column">
        <div fxLayout="row" class="table-like--header-row">
          <div fxFlex="44px"></div>
          <div fxFlex class="table-like--cell">
            {{
              'patient-details.eligibility-card.section-table.service-types'
                | translate
            }}
          </div>
          <div fxFlex="100px" class="table-like--cell table-like--center">
            {{
              'patient-details.eligibility-card.section-table.cov-level'
                | translate
            }}
          </div>
          <div fxFlex="400px" fxFlex.lt-xl="150px" class="table-like--cell table-like--center">
            {{
              'patient-details.eligibility-card.section-table.benefit-amount'
                | translate
            }}
          </div>
          <div fxFlex="75px" class="table-like--cell network-status table-like--center">
            {{
              'patient-details.eligibility-card.section-table.network'
                | translate
            }}
          </div>
          <div fxFlex="25px"></div>
        </div>
        <div class="scroll-area" fxLayout="column">
          <ng-container
            *ngFor="let deductible of eligibility.data.coverage.deductibles"
          >
            <div
              *ngIf="shouldDisplay(deductible)"
              class="table-like--row"
              [class.selected]="deductible.selected"
              [class.disabled]="disabled"
              fxLayout="row"
              fxLayoutAlign="start center"
              fxLayoutGap="0.5rem"
              (click)="
                !disabled && selectCoverageType('deductibles', deductible)
              "
            >
              <div fxFlex="28px">
                <mat-radio-button
                  name="deductible"
                  [disabled]="disabled"
                  [checked]="deductible.selected"
                ></mat-radio-button>
              </div>
              <div fxFlex fxLayout="column">
                <div fxLayout="row" fxLayoutAlign="start center">
                  <div fxFlex class="table-like--cell">
                    <ul class="series">
                      <li
                        *ngFor="let line of getServiceTypes(deductible)"
                        [innerHTML]="line"
                      ></li>
                    </ul>
                  </div>
                  <div fxFlex="100px" class="table-like--cell table-like--center">
                    {{ deductible.coverage_level | mmxTitlecase }}
                  </div>
                  <div
                    class="table-like--cell table-like--center"
                    fxFlex="400px"
                    fxFlex.lt-xl="150px"
                    fxLayout="row"
                    fxLayoutAlign="start center"
                    fxLayoutGap="0.25rem"
                    fxLayout.lt-xl="column"
                  >
                    <span class="text-sm">{{
                      deductible.time_period | mmxTitlecase
                    }}</span>
                    <span>{{
                      deductible.benefit_amount?.amount
                        | currency: deductible.benefit_amount?.currency
                    }}</span>
                    <ng-container *ngIf="deductible.remaining_amount">
                      <span fxHide.lt-xl>/</span>
                      <span class="text-sm">{{
                        'patient-details.eligibility-card.remaining'
                          | translate
                      }}</span>
                      <span class="text-warn">{{
                        deductible.remaining_amount?.amount
                          | currency: deductible.remaining_amount?.currency
                      }}</span>
                    </ng-container>
                  </div>
                  <div fxFlex="75px" class="table-like--cell network-status table-like--center">
                    {{ inNetworkDisplay(deductible.in_plan_network) }}
                  </div>
                </div>
                <div fxLayout="row">
                  <div fxFlex class="table-like--cell">
                    <mmx-eligibility-benefit-details
                      [benefit]="deductible"
                      [planStartDate]="getPlanFact('planStartDate')"
                      [planEndDate]="getPlanFact('planEndDate')"
                    ></mmx-eligibility-benefit-details>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <div
            class="table-like--row"
            [class.disabled]="disabled"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="0.5rem"
            (click)="!disabled && selectCoverageType('deductibles', 'none')"
          >
            <div fxFlex="28px">
              <mat-radio-button
                name="deductible"
                [disabled]="disabled"
                [checked]="hasNo('deductibles')"
              ></mat-radio-button>
            </div>
            <div class="table-like--cell" fxFlex fxLayout="column">
              {{ 'common.none' | translate }}.
              {{
                'patient-details.eligibility-card.remove-selection-deductible'
                  | translate
              }}.
            </div>
          </div>
        </div>
      </mat-panel-content>
    </mat-expansion-panel>

    <!-- Copayment -->
    <mat-expansion-panel
      *ngIf="
        eligibility &&
        eligibility.data &&
        eligibility.data.coverage &&
        hasSome(eligibility.data.coverage.copay)
      "
      [expanded]="eligibility.selectedCopayment == null"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'patient-details.eligibility-card.copayment' | translate }}
        </mat-panel-title>
        <mat-panel-description
          *ngIf="eligibility.selectedCopayment === 'none'"
        >
          <span class="text-warn">{{ 'common.none' | translate }}</span>
        </mat-panel-description>
        <mat-panel-description
          *ngIf="
            eligibility.selectedCopayment &&
            eligibility.selectedCopayment !== 'none' &&
            eligibility.selectedCopayment.copayment
          "
        >
          <span *ngIf="eligibility.selectedCopayment.ppSelected" class="text-secondary">
            ({{ 'patient-details.eligibility-card.auto-selected' | translate }})&nbsp;
          </span>
          {{
            eligibility.selectedCopayment.copayment.amount
              | currency: eligibility.selectedCopayment.copayment.currency
          }}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <mat-panel-content class="panel-content table-like" fxLayout="column">
        <div fxLayout="row" class="table-like--header-row">
          <div fxFlex="44px"></div>
          <div fxFlex class="table-like--cell">
            {{
              'patient-details.eligibility-card.section-table.service-types'
                | translate
            }}
          </div>
          <div fxFlex="100px" class="table-like--cell table-like--center">
            {{
              'patient-details.eligibility-card.section-table.cov-level'
                | translate
            }}
          </div>
          <div fxFlex="82px" class="table-like--cell table-like--center">
            {{
              'patient-details.eligibility-card.section-table.auth-req'
                | translate
            }}
          </div>
          <div fxFlex="100px" class="table-like--cell table-like--numeric">
            {{
              'patient-details.eligibility-card.section-table.copayment'
                | translate
            }}
          </div>
          <div fxFlex="75px" class="table-like--cell network-status table-like--center">
            {{
              'patient-details.eligibility-card.section-table.network'
                | translate
            }}
          </div>
          <div fxFlex="25px"></div>
        </div>
        <div class="scroll-area" fxLayout="column">
          <ng-container *ngFor="let copay of eligibility.data.coverage.copay">
            <div
              *ngIf="shouldDisplay(copay)"
              class="table-like--row"
              [class.selected]="copay.selected"
              [class.disabled]="disabled"
              fxLayout="row"
              fxLayoutAlign="start center"
              fxLayoutGap="0.5rem"
              (click)="!disabled && selectCoverageType('copay', copay)"
            >
              <div fxFlex="28px">
                <mat-radio-button
                  name="copayment"
                  [disabled]="disabled"
                  [checked]="copay.selected"
                ></mat-radio-button>
              </div>
              <div fxFlex fxLayout="column">
                <div fxLayout="row" fxLayoutAlign="start center">
                  <div fxFlex class="table-like--cell">
                    <ul class="series">
                      <li
                        *ngFor="let line of getServiceTypes(copay)"
                        [innerHTML]="line"
                      ></li>
                    </ul>
                  </div>
                  <div fxFlex="100px" class="table-like--cell table-like--center">
                    <ng-container *ngIf="copay.coverage_level">
                      {{ copay.coverage_level | mmxTitlecase }}
                    </ng-container>
                  </div>
                  <div fxFlex="82px" class="table-like--cell table-like--center">
                    <ng-container *ngIf="copay.authorization_required">
                      {{ copay.authorization_required | mmxTitlecase }}
                    </ng-container>
                  </div>
                  <div
                    fxFlex="100px"
                    class="table-like--cell table-like--numeric"
                  >
                    {{
                      copay.copayment?.amount
                        | currency: copay.copayment?.currency
                    }}
                  </div>
                  <div fxFlex="75px" class="table-like--cell network-status table-like--center">
                    {{ inNetworkDisplay(copay.in_plan_network) }}
                  </div>
                </div>
                <div fxLayout="row">
                  <div fxFlex class="table-like--cell">
                    <div *ngIf="copay.procedure_id">
                      <span class="label"
                        >{{
                          'patient-details.eligibility-card.procedure-id'
                            | translate
                        }}:</span
                      >
                      {{ copay.procedure_id }}
                    </div>
                    <div *ngIf="copay.procedure_id_qualifier">
                      <span class="label"
                        >{{
                          'patient-details.eligibility-card.procedure-id-qua'
                            | translate
                        }}:</span
                      >
                      {{ copay.procedure_id_qualifier }}
                    </div>
                    <mmx-eligibility-benefit-details
                      [benefit]="copay"
                      [planStartDate]="getPlanFact('planStartDate')"
                      [planEndDate]="getPlanFact('planEndDate')"
                    ></mmx-eligibility-benefit-details>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <div
            class="table-like--row"
            [class.disabled]="disabled"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="0.5rem"
            (click)="!disabled && selectCoverageType('copay', 'none')"
          >
            <div fxFlex="28px">
              <mat-radio-button
                name="copayment"
                [disabled]="disabled"
                [checked]="hasNo('copay')"
              ></mat-radio-button>
            </div>
            <div class="table-like--cell" fxFlex fxLayout="column">
              {{ 'common.none' | translate }}.
              {{
                'patient-details.eligibility-card.remove-selection-copay'
                  | translate
              }}.
            </div>
          </div>
        </div>
      </mat-panel-content>
    </mat-expansion-panel>

    <!-- Coinsurance-->
    <mat-expansion-panel
      *ngIf="
        eligibility &&
        eligibility.data &&
        eligibility.data.coverage &&
        hasSome(eligibility.data.coverage.coinsurance)
      "
      [expanded]="eligibility.selectedCoinsurance == null"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'patient-details.eligibility-card.coinsurance' | translate }}
        </mat-panel-title>
        <mat-panel-description
          *ngIf="eligibility.selectedCoinsurance === 'none'"
        >
          <span class="text-warn">{{ 'common.none' | translate }}</span>
        </mat-panel-description>
        <mat-panel-description
          *ngIf="
            eligibility.selectedCoinsurance &&
            eligibility.selectedCoinsurance !== 'none'
          "
        >
          <span *ngIf="eligibility.selectedCoinsurance.ppSelected" class="text-secondary">
            ({{ 'patient-details.eligibility-card.auto-selected' | translate }})&nbsp;
          </span>
          {{ eligibility.selectedCoinsurance.benefit_percent * 100 }}%
        </mat-panel-description>
      </mat-expansion-panel-header>
      <mat-panel-content class="panel-content table-like" fxLayout="column">
        <div fxLayout="row" class="table-like--header-row">
          <div fxFlex="44px"></div>
          <div fxFlex class="table-like--cell">
            {{
              'patient-details.eligibility-card.section-table.service-types'
                | translate
            }}
          </div>
          <div fxFlex="100px" class="table-like--cell table-like--center">
            {{
              'patient-details.eligibility-card.section-table.cov-level'
                | translate
            }}
          </div>
          <div fxFlex="82px" class="table-like--cell table-like--center">
            {{
              'patient-details.eligibility-card.section-table.auth-req'
                | translate
            }}
          </div>
          <div fxFlex="115px" class="table-like--cell table-like--numeric">
            {{
              'patient-details.eligibility-card.section-table.benefit-percent'
                | translate
            }}
          </div>
          <div fxFlex="75px" class="table-like--cell network-status table-like--center">
            {{
              'patient-details.eligibility-card.section-table.network'
                | translate
            }}
          </div>
          <div fxFlex="25px"></div>
        </div>
        <div class="scroll-area" fxLayout="column">
          <ng-container
            *ngFor="let coinsurance of eligibility.data.coverage.coinsurance"
          >
            <div
              *ngIf="shouldDisplay(coinsurance)"
              class="table-like--row"
              [class.selected]="coinsurance.selected"
              [class.disabled]="disabled"
              fxLayout="row"
              fxLayoutAlign="start center"
              fxLayoutGap="0.5rem"
              (click)="
                !disabled && selectCoverageType('coinsurance', coinsurance)
              "
            >
              <div fxFlex="28px">
                <mat-radio-button
                  name="coinsurance"
                  [disabled]="disabled"
                  [checked]="coinsurance.selected"
                ></mat-radio-button>
              </div>
              <div fxFlex fxLayout="column">
                <div fxLayout="row" fxLayoutAlign="start center">
                  <div fxFlex class="table-like--cell">
                    <ul class="series">
                      <li
                        *ngFor="let line of getServiceTypes(coinsurance)"
                        [innerHTML]="line"
                      ></li>
                    </ul>
                  </div>
                  <div fxFlex="100px" class="table-like--cell table-like--center">
                    <ng-container *ngIf="coinsurance.coverage_level">
                      {{ coinsurance.coverage_level | mmxTitlecase }}
                    </ng-container>
                  </div>
                  <div fxFlex="82px" class="table-like--cell table-like--center">
                    <ng-container *ngIf="coinsurance.authorization_required">
                      {{ coinsurance.authorization_required | mmxTitlecase }}
                    </ng-container>
                  </div>
                  <div
                    fxFlex="115px"
                    class="table-like--cell table-like--numeric"
                  >
                    {{ coinsurance.benefit_percent * 100 }}%
                  </div>
                  <div fxFlex="75px" class="table-like--cell network-status table-like--center">
                    {{ inNetworkDisplay(coinsurance.in_plan_network) }}
                  </div>
                </div>
                <div fxLayout="row">
                  <div fxFlex class="table-like--cell">
                    <div *ngIf="coinsurance.description">
                      <span class="label"
                        >{{ 'common.description' | translate }}:</span
                      >
                      {{ coinsurance.description }}
                    </div>
                    <!-- <div *ngIf="coinsurance.coverage_level">
                      <span class="label">Coverage Level:</span>
                      {{ coinsurance.coverage_level | mmxTitlecase }}
                    </div> -->
                    <!-- <div *ngIf="coinsurance.authorization_required">
                      <span class="label">Authorization Required:</span>
                      {{ coinsurance.authorization_required | mmxTitlecase }}
                    </div> -->
                    <div *ngIf="coinsurance.procedure_id">
                      <span class="label"
                        >{{
                          'patient-details.eligibility-card.procedure-id'
                            | translate
                        }}:</span
                      >
                      {{ coinsurance.procedure_id }}
                    </div>
                    <div *ngIf="coinsurance.procedure_id_qualifier">
                      <span class="label"
                        >{{
                          'patient-details.eligibility-card.procedure-id-qua'
                            | translate
                        }}:</span
                      >
                      {{ coinsurance.procedure_id_qualifier }}
                    </div>
                    <mmx-eligibility-benefit-details
                      [benefit]="coinsurance"
                      [planStartDate]="getPlanFact('planStartDate')"
                      [planEndDate]="getPlanFact('planEndDate')"
                    ></mmx-eligibility-benefit-details>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <div
            class="table-like--row"
            [class.disabled]="disabled"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="0.5rem"
            (click)="!disabled && selectCoverageType('coinsurance', 'none')"
          >
            <div fxFlex="28px">
              <mat-radio-button
                name="coinsurance"
                [disabled]="disabled"
                [checked]="hasNo('coinsurance')"
              ></mat-radio-button>
            </div>
            <div class="table-like--cell" fxFlex fxLayout="column">
              {{ 'common.none' | translate }}.
              {{
                'patient-details.eligibility-card.remove-selection-coinsurance'
                  | translate
              }}.
            </div>
          </div>
        </div>
      </mat-panel-content>
    </mat-expansion-panel>

    <!-- Out Of Pocket Max -->
    <mat-expansion-panel
      *ngIf="
        eligibility &&
        eligibility.data &&
        eligibility.data.coverage &&
        hasSome(eligibility.data.coverage.out_of_pocket)
      "
      [expanded]="eligibility.selectedOutOfPocketMax == null"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'patient-details.eligibility-card.out-of-pocket' | translate }}
        </mat-panel-title>
        <mat-panel-description
          *ngIf="eligibility.selectedOutOfPocketMax === 'none'"
        >
          <span class="text-warn">{{ 'common.none' | translate }}</span>
        </mat-panel-description>
        <mat-panel-description
          *ngIf="
            eligibility.selectedOutOfPocketMax &&
            eligibility.selectedOutOfPocketMax !== 'none' &&
            eligibility.selectedOutOfPocketMax.benefit_amount
          "
        >
          <span *ngIf="eligibility.selectedOutOfPocketMax.ppSelected" class="text-secondary">
            ({{ 'patient-details.eligibility-card.auto-selected' | translate }})&nbsp;
          </span>
          {{
            eligibility.selectedOutOfPocketMax.benefit_amount.amount
              | currency
                : eligibility.selectedOutOfPocketMax.benefit_amount.currency
          }}
          {{ eligibility.selectedOutOfPocketMax.time_period | mmxTitlecase }}
          <ng-container
            *ngIf="eligibility.selectedOutOfPocketMax.remaining_amount"
          >
            /
            {{
              eligibility.selectedOutOfPocketMax.remaining_amount?.amount
                | currency
                  : eligibility.selectedOutOfPocketMax.remaining_amount
                      ?.currency
            }}
            {{ 'patient-details.eligibility-card.remaining' | translate }}
          </ng-container>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <mat-panel-content class="panel-content table-like" fxLayout="column">
        <div fxLayout="row" class="table-like--header-row">
          <div fxFlex="44px"></div>
          <div fxFlex class="table-like--cell">
            {{ 'patient-details.eligibility-card.service-types' | translate }}
          </div>
          <div fxFlex="100px" class="table-like--cell table-like--center">
            {{
              'patient-details.eligibility-card.section-table.cov-level'
                | translate
            }}
          </div>
          <div fxFlex="400px" fxFlex.lt-xl="150px" class="table-like--cell table-like--center">
            {{
              'patient-details.eligibility-card.section-table.benefit-amount'
                | translate
            }}
          </div>
          <div fxFlex="75px" class="table-like--cell network-status table-like--center">
            {{
              'patient-details.eligibility-card.section-table.network'
                | translate
            }}
          </div>
          <div fxFlex="25px"></div>
        </div>
        <div class="scroll-area" fxLayout="column">
          <ng-container
            *ngFor="let oop of eligibility.data.coverage.out_of_pocket"
          >
            <div
              *ngIf="shouldDisplay(oop)"
              class="table-like--row"
              [class.selected]="oop.selected"
              [class.disabled]="disabled"
              fxLayout="row"
              fxLayoutAlign="start center"
              fxLayoutGap="0.5rem"
              (click)="!disabled && selectCoverageType('out_of_pocket', oop)"
            >
              <div fxFlex="28px">
                <mat-radio-button
                  name="oop"
                  [disabled]="disabled"
                  [checked]="oop.selected"
                ></mat-radio-button>
              </div>
              <div fxFlex fxLayout="column">
                <div fxLayout="row" fxLayoutAlign="start center">
                  <div fxFlex class="table-like--cell">
                    <ul class="series">
                      <li
                        *ngFor="let line of getServiceTypes(oop)"
                        [innerHTML]="line"
                      ></li>
                    </ul>
                  </div>
                  <div fxFlex="100px" class="table-like--cell table-like--center">
                    {{ oop.coverage_level | mmxTitlecase }}
                  </div>
                  <div
                    class="table-like--cell table-like--center"
                    fxFlex="400px"
                    fxFlex.lt-xl="150px"
                    fxLayout="row"
                    fxLayoutAlign="start center"
                    fxLayoutGap="0.25rem"
                    fxLayout.lt-xl="column"
                  >
                    <span class="text-sm">{{
                      oop.time_period | mmxTitlecase
                    }}</span>
                    <div>
                      {{
                        oop.benefit_amount?.amount
                          | currency: oop.benefit_amount?.currency
                      }}
                    </div>
                    <ng-container *ngIf="oop.remaining_amount">
                      <span fxHide.lt-xl>/</span>
                      <span class="text-sm">Remaining</span>
                      <span class="text-warn">{{
                        oop.remaining_amount?.amount
                          | currency: oop.remaining_amount?.currency
                      }}</span>
                    </ng-container>
                  </div>
                  <div fxFlex="75px" class="table-like--cell network-status table-like--center">
                    {{ inNetworkDisplay(oop.in_plan_network) }}
                  </div>
                </div>
                <div fxLayout="row">
                  <div fxFlex class="table-like--cell">
                    <mmx-eligibility-benefit-details
                      [benefit]="oop"
                      [planStartDate]="getPlanFact('planStartDate')"
                      [planEndDate]="getPlanFact('planEndDate')"
                    ></mmx-eligibility-benefit-details>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <div
            class="table-like--row"
            [class.disabled]="disabled"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="0.5rem"
            (click)="!disabled && selectCoverageType('out_of_pocket', 'none')"
          >
            <div fxFlex="28px">
              <mat-radio-button
                name="out_of_pocket"
                [disabled]="disabled"
                [checked]="hasNo('out_of_pocket')"
              ></mat-radio-button>
            </div>
            <div class="table-like--cell" fxFlex fxLayout="column">
              {{ 'common.none' | translate }}.
              {{
                'patient-details.eligibility-card.remove-selection-out-of-pocket'
                  | translate
              }}.
            </div>
          </div>
        </div>
      </mat-panel-content>
    </mat-expansion-panel>

    <!-- Limitations -->
    <mat-expansion-panel
      *ngIf="
        eligibility &&
        eligibility.data &&
        eligibility.data.coverage &&
        hasSome(eligibility.data.coverage.limitations)
      "
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'patient-details.eligibility-card.limitations' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <mat-panel-content class="panel-content table-like" fxLayout="column">
        <div fxLayout="row" class="table-like--header-row">
          <div fxFlex class="table-like--cell">
            {{ 'patient-details.eligibility-card.service-types' | translate }}
          </div>
          <div fxFlex="100px" class="table-like--cell table-like--center">
            {{
              'patient-details.eligibility-card.section-table.cov-level'
                | translate
            }}
          </div>
          <div fxFlex="82px" class="table-like--cell table-like--center">
            {{
              'patient-details.eligibility-card.section-table.auth-req'
                | translate
            }}
          </div>
          <div fxFlex="400px" fxFlex.lt-xl="150px" class="table-like--cell table-like--center">
            {{
              'patient-details.eligibility-card.section-table.benefit-amount'
                | translate
            }}
          </div>
          <div fxFlex="75px" class="table-like--cell network-status table-like--center">
            {{
              'patient-details.eligibility-card.section-table.network'
                | translate
            }}
          </div>
          <div fxFlex="25px"></div>
        </div>
        <div class="scroll-area" fxLayout="column">
          <ng-container
            *ngFor="let limitation of eligibility.data.coverage.limitations"
          >
            <div
              *ngIf="shouldDisplay(limitation)"
              class="table-like--row table-like--not-selectable"
              [class.selected]="limitation.selected"
              fxLayout="column"
            >
              <div fxLayout="row">
                <div fxFlex class="table-like--cell">
                  <ul class="series">
                    <li
                      *ngFor="let line of getServiceTypes(limitation)"
                      [innerHTML]="line"
                    ></li>
                  </ul>
                </div>
                <div fxFlex="100px" class="table-like--cell table-like--center">
                  {{ limitation.coverage_level | mmxTitlecase }}
                </div>
                <div fxFlex="82px" class="table-like--cell table-like--center">
                  <ng-container *ngIf="limitation.authorization_required">
                    {{ limitation.authorization_required | mmxTitlecase }}
                  </ng-container>
                </div>
                <div
                  class="table-like--cell table-like--center"
                  fxFlex="400px"
                  fxFlex.lt-xl="150px"
                  fxLayout="row"
                  fxLayoutAlign="start center"
                  fxLayoutGap="0.25rem"
                  fxLayout.lt-xl="column"
                >
                  <div class="text-sm">
                    {{
                      limitation.time_period || 'calendar_year' | mmxTitlecase
                    }}
                  </div>
                  <div>
                    {{
                      limitation.benefit_amount?.amount
                        | currency: limitation.benefit_amount?.currency
                    }}
                  </div>
                  <ng-container *ngIf="limitation.remaining_amount">
                    <span fxHide.lt-xl>/</span>
                    <span class="text-sm">{{
                      'patient-details.eligibility-card.remaining' | translate
                    }}</span>
                    <span class="text-warn">{{
                      limitation.remaining_amount?.amount
                        | currency: limitation.remaining_amount?.currency
                    }}</span>
                  </ng-container>
                </div>
                <div fxFlex="75px" class="table-like--cell network-status table-like--center">
                  {{ inNetworkDisplay(limitation.in_plan_network) }}
                </div>
              </div>
              <div fxLayout="row">
                <!-- <tr class="mat-row" *ngIf="(limitation.description || limitation.quantity || limitation.authorization_required || limitation.place_of_service || limitation.messages?.length > 0) && shouldDisplay(limitation)"></tr> -->
                <div fxFlex class="table-like--cell">
                  <div *ngIf="limitation.description">
                    <span class="label"
                      >{{ 'common.description' | translate }}:</span
                    >
                    {{ limitation.description }}
                  </div>

                  <div *ngIf="limitation.quantity">
                    <span class="label"
                      >{{
                        'patient-details.eligibility-card.quantity'
                          | translate
                      }}:</span
                    >
                    {{ limitation.quantity }}
                    {{ limitation.quantity_qualifier | mmxTitlecase }}
                  </div>

                  <!-- <div *ngIf="limitation.authorization_required">
                    <span class="label">Authorization Required:</span>
                    {{ limitation.authorization_required | mmxTitlecase }}
                  </div> -->

                  <div *ngIf="limitation.place_of_service">
                    <span class="label"
                      >{{
                        'patient-details.eligibility-card.place-of-service'
                          | translate
                      }}:</span
                    >
                    {{ limitation.place_of_service | mmxTitlecase }}
                  </div>

                  <mmx-eligibility-messages [messages]="limitation.messages"></mmx-eligibility-messages>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </mat-panel-content>
    </mat-expansion-panel>
  </mat-accordion>
</mat-card-content>
